import { t } from '@lingui/core/macro';
import { ComponentOrigin } from '@luminovo/api-contracts';
import { assertUnreachable } from '@luminovo/commons';
import { Tag, Tooltip } from '@luminovo/design-system';

export function getComponentOrigin(origin: ComponentOrigin) {
    switch (origin.type) {
        case 'Import':
            return t`Imported`;
        case 'Manual':
            return t`Manual`;
        case 'UserDefined':
            return origin.context.context;
        default:
            assertUnreachable(origin);
    }
}

export const ComponentOriginTag = ({ origin }: { origin: ComponentOrigin }) => {
    switch (origin.type) {
        case 'Import':
            return (
                <Tooltip title={t`Component imported via the API`}>
                    <Tag label={t`Imported`} attention="low" color="neutral" />
                </Tooltip>
            );
        case 'Manual':
            return (
                <Tooltip title={t`Component manually created `}>
                    <Tag label={t`Manual`} attention="low" color="neutral" />
                </Tooltip>
            );
        case 'UserDefined':
            return (
                <Tooltip title={t`Component imported via the API with origin: ${origin.context.context}`}>
                    <Tag label={origin.context.context} attention="low" color="neutral" />
                </Tooltip>
            );
        default:
            assertUnreachable(origin);
    }
};
